// Author Liang Gang Qiang
// Date 2021-11-26 16:32:46

class MintalMesQualityProject {
constructor({
        id = null,
        locationId = '',
        code = '',
        name = '',
        craftType = '',
        qualityType = '',
        remark = '',
        uniqueCode = ''}
= {}) {
    this.id = id;
    this.locationId = locationId;
    this.code = code;
    this.name = name;
    this.craftType = craftType;
    this.qualityType = qualityType;
    this.remark = remark;
    this.uniqueCode = uniqueCode;
}
}

function newEntity() {
return new MintalMesQualityProject();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.quality.mintalMesQualityProject.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'locationName',
        label: 'label.mintal.quality.mintalMesQualityProject.grid.locationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.mintal.quality.mintalMesQualityProject.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.mintal.quality.mintalMesQualityProject.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'craftType',
        label: 'label.mintal.quality.mintalMesQualityProject.grid.craftType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '球团' },
                            { value: '2', text: '冶炼' },
                            { value: '3', text: '原料入库' },
                            { value: '4', text: '原料出库' },
                            { value: '5', text: '产品入库' },
                            { value: '6', text: '产品出库' }
            ]
        }
        },
        {
        key: 'qualityType',
        label: 'label.mintal.quality.mintalMesQualityProject.grid.qualityType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '原料检验' },
                            { value: '2', text: '过程检验' },
                            { value: '3', text: '成品检验' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualityProject.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'uniqueCode',
        label: 'label.mintal.quality.mintalMesQualityProject.grid.uniqueCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    locationIdFilter : '',
    codeFilter : '',
    nameFilter : '',
    craftTypeFilter : '',
    qualityTypeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'locationIdFilter',
        label: 'label.mintal.quality.mintalMesQualityProject.filter.locationId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'codeFilter',
        label: 'label.mintal.quality.mintalMesQualityProject.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.mintal.quality.mintalMesQualityProject.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'craftTypeFilter',
        label: 'label.mintal.quality.mintalMesQualityProject.filter.craftType',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '球团' },
                { value: '2', text: '冶炼' },
                { value: '3', text: '原料入库' },
                { value: '4', text: '原料出库' },
                { value: '5', text: '产品入库' },
                { value: '6', text: '产品出库' }
            ]
        }
        },
        {
        key: 'qualityTypeFilter',
        label: 'label.mintal.quality.mintalMesQualityProject.filter.qualityType',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '原料检验' },
                { value: '2', text: '过程检验' },
                { value: '3', text: '成品检验' }
            ]
        }
        }
];


    const entityFormConfigs = [
        {
        key: 'locationId',
        label: 'label.mintal.quality.mintalMesQualityProject.entity.locationId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'code',
        label: 'label.mintal.quality.mintalMesQualityProject.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'name',
        label: 'label.mintal.quality.mintalMesQualityProject.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'craftType',
        label: 'label.mintal.quality.mintalMesQualityProject.entity.craftType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '球团' },
                { value: '2', text: '冶炼' },
                { value: '3', text: '原料入库' },
                { value: '4', text: '原料出库' },
                { value: '5', text: '产品入库' },
                { value: '6', text: '产品出库' }
            ]
        }
        },
        {
        key: 'qualityType',
        label: 'label.mintal.quality.mintalMesQualityProject.entity.qualityType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '原料检验' },
                { value: '2', text: '过程检验' },
                { value: '3', text: '成品检验' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.quality.mintalMesQualityProject.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'uniqueCode',
        label: 'label.mintal.quality.mintalMesQualityProject.entity.uniqueCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        }
]

export {MintalMesQualityProject, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
